<template>
    <div class="app-container" style="background-color: #f9fbff;">
        <div class="review-title-content">
            <div class="reasons-title">
                <h3>街角給湯相談所の口コミ</h3>
            </div>
        </div>
        <div class="card">
            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">電話したらすぐにかけつけて見てくれたのでとても助かりました。</p>
                <p class="review-content-text"><span class="under-yellow">作業がとても丁寧で、対応も良かったです。<br></span>おかげで現在は順調に動いています。</p>
                <p class="google-review">引用：公式サイト</p>
            </div>

            <div class="review-content">
                <div class="review-header">
                    <div class="rating-point-box">
                        <img src="../../assets/google-review.png" alt="">
                        <span class="rating-stars">★★★★★</span>
                        <span class="rating-score">評価５</span>
                    </div>
                </div>
                <p class="review-content-text">エラーコードが出て、対応がわからずお電話しました。</p>
                <p class="review-content-text">電話対応も好感が持てましたし、来て頂いた担当の方も素晴らしかったです。</p>
                <p class="review-content-text"><span class="under-yellow">説明もわかりやすく、工事も素早くやってくださり、あっという間に終わった</span>のでびっくりしました。</p>
                <p class="google-review">引用：公式サイト</p>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>

<style scoped>
.app-container {
    background: #f9fbff;
    padding: 40px 20px;
}

.reasons-title {
    margin-bottom: 30px;
    text-align: center;
}

.reasons-title h3 {
    font-size: 32px;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
    background: linear-gradient(90deg, #3f51b5, #3F51B5);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.reasons-title h3::after {
    content: "";
    display: block;
    width: 80px;
    height: 4px;
    background: #3f51b5;
    margin: 12px auto 0;
    border-radius: 2px;
}

.card {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.review-content {
    background: #fff;
    padding: 25px 20px;
    border: 1px solid #eee;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    text-align: left;
}


.review-header {
    margin-bottom: 12px;
}

.rating-point-box {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;
}

.rating-stars {
    color: #ffc107;
    font-size: 18px;
    letter-spacing: 2px;
}

.rating-score {
    font-size: 18px;
    font-weight: bold;
    color: #d9534f;
}

.google-review {
    text-align: right;
    font-size: 12px;
    padding-bottom: 0;
    margin-bottom: 0;
}

.review-header img {
    width: 60px;
    height: auto;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .review-content-text {
        font-size: 0.9rem;
    }

    .google-review {
        font-size: 0.7rem;
    }

    .rating-point-box img {
        width: 20%;
    }

    .rating-stars,
    .rating-score {
        font-size: 0.9rem;
    }

    .reasons-title h3 {
        font-size: 1.5rem
    }

    .rating-stars {
        font-size: 1.2rem;
    }
}
</style>
